import { ExperimentsTableRow } from 'modules/experiments/types';
import { getUnfinishedExperimentStates } from 'modules/experiments/utils';
import { STATES_WITH_LAUNCH_ACTION as UNLAUNCHED_STATES } from 'modules/experiments/constants';
import { useExperimentsTranslations } from 'modules/experiments/hooks';
import { useExperimentTakeover } from 'modules/experiments/takeover';
import { ExperimentTakeoverSource } from 'modules/experiments/takeover/constants';
import { GridRow } from 'ui/indexPages/tables/grid';
import {
  NameCell,
  StatusCell,
  BaseCell,
  DateCell,
  WinningCriteriaCell,
  LastModifiedCell,
} from './cells';
import { ExperimentActionMenu } from './ExperimentActionMenu';

type ExperimentRowProps = {
  experiment: ExperimentsTableRow;
  tableGrid: string;
};
export const ExperimentRow = ({ experiment, tableGrid }: ExperimentRowProps) => {
  const { t } = useExperimentsTranslations();
  const { getExperimentLinkAttributes } = useExperimentTakeover();
  const {
    id,
    type: subject,
    state: status,
    startedAt: startDate,
    endedAt: endDate,
    winningCriteria,
    createdAt,
    createdBy,
    modifiedAt,
    campaign,
    campaign: { type: campaignType },
  } = experiment;

  // Custom Date Display
  const CUSTOM_DATE_DISPLAYS = {
    NOT_LAUNCHED: t('table.dateCell.notLaunched'),
    NOT_APPLICABLE: t('table.dateCell.notApplicable'),
  };

  const customStartDisplay = UNLAUNCHED_STATES.includes(status)
    ? CUSTOM_DATE_DISPLAYS.NOT_LAUNCHED
    : '';
  const customEndDisplay = getUnfinishedExperimentStates(campaignType).includes(status)
    ? CUSTOM_DATE_DISPLAYS.NOT_APPLICABLE
    : '';

  const experimentLinkAttributes = getExperimentLinkAttributes({
    source: ExperimentTakeoverSource.EXPERIMENT_NAME_INDEX,
    experiment,
    campaign,
  });

  return (
    <GridRow gridLayout={tableGrid} data-test={`experiment-grid-row-${id}`}>
      {/* For multi-select */}
      {/* <CheckboxGridCell id={id} handleClick={onCheckboxClick} status={CHECKBOX_STATUS.UNCHECKED} /> */}
      <NameCell experiment={experiment} experimentLinkAttributes={experimentLinkAttributes} />
      <BaseCell value={t(`experimentType.${subject}`)} />
      <WinningCriteriaCell {...winningCriteria} />
      <StatusCell status={status} />
      <DateCell date={startDate} customDisplay={customStartDisplay} />
      <DateCell date={endDate} customDisplay={customEndDisplay} />
      <LastModifiedCell
        createdBy={{ ...createdBy, emailAddress: createdBy.id }}
        createdAt={createdAt}
        modifiedAt={modifiedAt}
      />
      <ExperimentActionMenu experiment={experiment} />
    </GridRow>
  );
};
